// extracted by mini-css-extract-plugin
export default {"quantity":"Quantity_quantity__vLpbm","quantityBtn":"Quantity_quantityBtn__aCvc2"};